import Assistir from './Assistir';
import Processar from './Processar';

export const AulasAssistir = Assistir;
export const AulasProcessar = Processar;
